import { buttons, forms, typography } from "@/styles/design-tokens";

interface MailchimpFormProps {
  url: string;
}

export default function MailchimpForm({ url }: MailchimpFormProps) {
  if (!url) return null;

  return (
    <form
      action={url}
      method="post"
      target="_blank"
      noValidate
      aria-label="Subscribe to newsletter"
      className="w-full max-w-[800px] mx-auto flex flex-col"
    >
      {/* First Name */}
      <div className={forms.fieldset}>
        <label htmlFor="mce-FNAME" className={forms.label}>
          First Name <span aria-hidden="true">*</span>
        </label>
        <input
          type="text"
          id="mce-FNAME"
          name="FNAME"
          required
          aria-required="true"
          placeholder="Your first name"
          className={forms.input}
        />
      </div>

      {/* Last Name */}
      <div className={forms.fieldset}>
        <label htmlFor="mce-LNAME" className={forms.label}>
          Last Name
        </label>
        <input
          type="text"
          id="mce-LNAME"
          name="LNAME"
          placeholder="Your last name"
          className={forms.input}
        />
      </div>

      {/* Email */}
      <div className={forms.fieldset}>
        <label htmlFor="mce-EMAIL" className={forms.label}>
          Email <span aria-hidden="true">*</span>
        </label>
        <input
          type="email"
          id="mce-EMAIL"
          name="EMAIL"
          required
          aria-required="true"
          placeholder="your@email.com"
          className={forms.input}
        />
      </div>

      {/* Phone Number */}
      <div className={forms.fieldset}>
        <label htmlFor="mce-PHONE" className={forms.label}>
          Phone Number
        </label>
        <input
          type="tel"
          id="mce-PHONE"
          name="PHONE"
          placeholder="(Optional)"
          pattern="[\+]?[0-9\s\-()]*"
          aria-describedby="phone-format"
          className={forms.input}
        />
      </div>

      {/* Sponsoring Checkbox */}
      <div className="flex items-center gap-2 px-6">
        <div className="rounded-full flex w-fit h-fit p-0.5 bg-white border-black border-2">
          <input
            id="sponsor-checkbox"
            name="SPONSOR"
            type="checkbox"
            value="Yes"
            className="appearance-none w-4 h-4 rounded-full cursor-pointer checked:bg-black"
            aria-checked="false"
          />
        </div>
        <label htmlFor="mce-SPONSOR" className={typography.bodySmall}>
          Check if you’re interested in Sponsoring!
        </label>
      </div>

      {/* Submit Button */}
      <button type="submit" className={`${buttons.primary} !w-full mt-8`}>
        <span className="glimmer">sign up</span>
      </button>
    </form>
  );
}
